module.exports = __webpack_public_path__ + "img/26.fa6bef45.png";